export const COUNTRY = 'COUNTRY';
export const MENU_STAT = 'MENU_STAT';
export const DESTROY_SESSION = 'DESTROY_SESSION';
export const LIST_QUERY_ITEMS = 'LIST_QUERY_ITEMS';
export const SIDE_MENU_STATS = 'SIDE_MENU_STATS';
export const ENTITY_STATISTICS = 'ENTITY_STATISTICS';
